import { render, staticRenderFns } from "./typeGroup.vue?vue&type=template&id=641f45aa&scoped=true&"
import script from "./typeGroup.vue?vue&type=script&lang=js&"
export * from "./typeGroup.vue?vue&type=script&lang=js&"
import style0 from "./typeGroup.vue?vue&type=style&index=0&id=641f45aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f45aa",
  null
  
)

export default component.exports